"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setScriptElementState = exports.mountRemoteEntryScript = exports.getScriptElementState = exports.getModuleScriptElement = exports.createModuleScriptElement = exports.ELEMENT_STATES = void 0;
var ELEMENT_STATES = {
  INIT: 'init',
  SUCCESS: 'success',
  ERROR: 'error'
};
exports.ELEMENT_STATES = ELEMENT_STATES;

var mountRemoteEntryScript = function mountRemoteEntryScript(remoteProps, onLoad, onError) {
  var scriptElement = createModuleScriptElement(remoteProps);
  setScriptElementState(scriptElement, ELEMENT_STATES.INIT);
  scriptElement.addEventListener('load', onLoad);
  scriptElement.addEventListener('error', onError);
  document.head.appendChild(scriptElement);
  return scriptElement;
};

exports.mountRemoteEntryScript = mountRemoteEntryScript;

var createModuleScriptElement = function createModuleScriptElement(remoteProps) {
  var url = remoteProps.url,
      remoteName = remoteProps.remoteName,
      module = remoteProps.module;
  var element = document.createElement('script');
  element.src = url;
  element.type = 'text/javascript';
  element.async = true;
  element.dataset['remote'] = remoteName;
  element.dataset['module'] = module;
  return element;
};

exports.createModuleScriptElement = createModuleScriptElement;

var getModuleScriptElement = function getModuleScriptElement(remoteName, module) {
  var query = "script[data-remote=\"".concat(remoteName, "\"][data-module=\"").concat(module, "\"]");
  var scriptElement = document.querySelector(query);
  return scriptElement;
};

exports.getModuleScriptElement = getModuleScriptElement;

var setScriptElementState = function setScriptElementState(scriptElement, state) {
  scriptElement.dataset['state'] = state;
};

exports.setScriptElementState = setScriptElementState;

var getScriptElementState = function getScriptElementState(scriptElement) {
  return scriptElement.dataset['state'];
};

exports.getScriptElementState = getScriptElementState;